<template>
  <div class="box2">
    <pageTitle
      title="核心优势" 
    />
 
    <div class="subject-box">
      <div class="item" v-for="(item, index) in items" :key="index">
        <img :src="item.image" />
        <h3>{{ item.title }}</h3>
        <p>{{ item.description1 }}</p>
        <p>{{ item.description2 }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      items: [
        {
          image: require('../../../assets/coursePage/stevens/box2/icon1.png'),
          title: '美百强校 网课同权',
          description1: '师资、权益、资源，',
          description2: '皆与本土等同'
        },
        {
          image: require('../../../assets/coursePage/stevens/box2/icon2.png'),
          title: '热门专业 前景广阔',
          description1: '数据科学/计算机科学',
          description2: '专业，就业率100%'
        },
        {
          image: require('../../../assets/coursePage/stevens/box2/icon3.png'),
          title: '学位证书全球认可',
          description1: '全日制硕士学位证书，海',
          description2: '牙、WES、NSC均可认证'
        },
        {
          image: require('../../../assets/coursePage/stevens/box2/icon4.png'),
          title: '模式灵活 双语学习',
          description1: '兼顾工作与生活',
          description2: '无语言学习障碍'
        },
        {
          image: require('../../../assets/coursePage/stevens/box2/icon5.png'),
          title: '学制短 学习自由',
          description1: '学制1.5-2年，学习进',
          description2: '度自由掌握'
        },
        {
          image: require('../../../assets/coursePage/stevens/box2/icon6.png'),
          title: '学习成本低',
          description1: '学费仅为传统留学',
          description2: '的五分之一'
        },
      ]
    };
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 0px 0 58px;
  width: 100%;
  background: #FFFFFF;
  /deep/.course-title-box .course-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #272020;
    line-height: 64px;
    text-align: center;
  }
  .subject-box {
    padding: 48px 40px 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      margin-bottom: 22px;
      width: 324px;
      height: 356px;
      background: #F7F7F7;
      border-radius: 24px;
      box-sizing: border-box;
      text-align: center;
      img {
        width: 92px;
        height: 92px;
        margin: 40px auto 0;
      }
      h3 {
        margin: 36px 0 12px;
        font-weight: bold;
        font-size: 32px;
        color: #231D1D;
        line-height: 48px;
        text-align: center;
      }
      p {
        font-weight: 400;
        font-size: 26px;
        color: #231D1D;
        line-height: 44px;
        text-align: center;
      }
    }
  }
}
</style>
